import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material.module';
import { PrimeModule } from './primeAngular.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { AppComponent } from './app.component';

import { NavbarComponent } from './components/common/navbar/navbar.component';
import { LoginComponent } from './components/common/login/login.component';
import { SignupComponent } from './components/common/signup/signup.component';
import { ReactiveFormsModule } from '@angular/forms'; 

import { DashBoardComponent } from './components/pages/dash-board/dash-board.component';
import { CardComponent } from './components/pages/dash-board/card/card.component';
import { DeviceTableComponent } from './components/pages/dash-board/device-table/device-table.component';
import { UploadmediaComponent } from './components/pages/dash-board/uploadmedia/uploadmedia.component';
import { RecentMessageTableComponent } from './components/pages/dash-board/recent-message-table/recent-message-table.component';

import { ChatComponent } from './components/pages/chat/chat.component';
import { ChatListComponent } from './components/pages/chat/chat-list/chat-list.component';
import { MessageScreenComponent } from './components/pages/chat/message-screen/message-screen.component';
import { RightSideBarCompComponent } from './components/pages/chat/right-side-bar-comp/right-side-bar-comp.component';
import { ShareContCompComponent } from './components/pages/chat/share-cont-comp/share-cont-comp.component';
import { SignatureCompComponent } from './components/pages/chat/signature-comp/signature-comp.component';
import { SideBarComponent } from './components/common/side-bar/side-bar.component';
import { SettingcompComponent } from './components/pages/chat/settingcomp/settingcomp.component';
import { RebootCompComponent } from './components/pages/chat/reboot-comp/reboot-comp.component';
import { PanelsmallscreencompchatComponent } from './components/pages/chat/panelsmallscreencompchat/panelsmallscreencompchat.component';
import { PanelcompchatComponent } from './components/pages/chat/panelcompchat/panelcompchat.component';
import { ChatheaderwincompComponent } from './components/pages/chat/chatheaderwincomp/chatheaderwincomp.component';
import { ContablecompComponent } from './components/pages/chat/contablecomp/contablecomp.component';
import { EditmodalcompComponent } from './components/pages/chat/editmodalcomp/editmodalcomp.component';
import { MoredevcompComponent } from './components/pages/chat/moredevcomp/moredevcomp.component';
import { NewchatmodalcompComponent } from './components/pages/chat/newchatmodalcomp/newchatmodalcomp.component';

import { DevicesScreenComponent } from './components/pages/devices-screen/devices-screen.component';
import { ConnectnewDeviceComponent } from './components/pages/connectnew-device/connectnew-device.component';
import { DeviceConnectSuccessComponent } from './components/pages/connectnew-device/device-connect-success/device-connect-success.component';

import { AccountComponent } from './components/pages/account/account.component';
import { ChangpasswordComponent } from './components/pages/account/changpassword/changpassword.component';
import { NotificationComponent } from './components/pages/account/notification/notification.component';
import { PaymentsCardComponent } from './components/pages/account/payments-card/payments-card.component';
import { AccountDetailsComponent } from './components/pages/account/account-details/account-details.component';

import { AddUsersComponent } from './components/pages/users/add-users/add-users.component';
import { ShowUsersComponent } from './components/pages/users/show-users/show-users.component';
import { UsersComponent } from './components/pages/users/users.component';

import { MainMComponent } from './components/pages/main-m/main-m.component';

import { RecentmessageService } from './service/recentmessage.service';
import { CountryService } from './service/country.service';
import { ChatsService } from './service/chats.service';
import { MessagesService } from './service/messages.service';
import { UsersService } from './service/users.service';
import { ContactsService } from './service/contacts.service';
import { RestorePasswordComponent } from './components/common/restore-password/restore-password.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { JwtInterceptorService } from './interceptor/jwt-interceptor.service';
import { ResponseHttpInterceptor } from './interceptor/response-http.interceptor';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ErrorHttpInterceptor } from './interceptor/error-http.interceptor';
import { SettingsComponent } from './components/pages/settings/settings.component';
import { WelcomeComponent } from './components/welcome/welcome.component'; // Importa WelcomeComponent
import { DialogModule } from 'primeng/dialog'; 
import { CampaignsComponent } from './components/pages/campaigns/campaigns.component';
import { EnvioMasivoMensajeComponent } from './components/pages/campaigns/envio-masivo-mensaje/envio-masivo-mensaje.component';
import { EnvioMasivoArchivoComponent } from './components/pages/campaigns/envio-masivo-archivo/envio-masivo-archivo.component';
import { MensajePersonalizadoGrupoComponent } from './components/pages/campaigns/mensaje-personalizado-grupo/mensaje-personalizado-grupo.component';
import { ArchivoPersonalizadoGrupoComponent } from './components/pages/campaigns/archivo-personalizado-grupo/archivo-personalizado-grupo.component';
import { ListaDeContactosComponent } from './components/pages/campaigns/lista-de-contactos/lista-de-contactos.component';
import { MisCampaniasComponent } from './components/pages/campaigns/mis-campanias/mis-campanias.component';
import { CrearContactosComponent } from './components/pages/campaigns/crear-contactos/crear-contactos.component';
import { EditarContactosComponent } from './components/pages/campaigns/editar-contactos/editar-contactos.component';
import { MisCampaniasDetallesComponent } from './components/pages/campaigns/mis-campanias-detalles/mis-campanias-detalles.component';

import { TableModule } from 'primeng/table'; // Importa TableModule desde PrimeNG
import {ButtonModule} from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { ConfirmationService } from 'primeng/api';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/lenguajes/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent, //common
    LoginComponent, 
    SignupComponent,
    DashBoardComponent, //dashboard
    CardComponent, 
    DeviceTableComponent,
    UploadmediaComponent, 
    RecentMessageTableComponent,
    ChatComponent, //chat
    ChatListComponent, 
    MessageScreenComponent,
    RightSideBarCompComponent,
    ShareContCompComponent, 
    SignatureCompComponent,
    SideBarComponent, 
    SettingcompComponent, 
    RebootCompComponent,
    PanelsmallscreencompchatComponent, 
    PanelcompchatComponent,
    ChatheaderwincompComponent, 
    ContablecompComponent, 
    EditmodalcompComponent,
    MoredevcompComponent, 
    NewchatmodalcompComponent,
    DevicesScreenComponent, //dispositivos
    ConnectnewDeviceComponent, 
    DeviceConnectSuccessComponent,
    AccountComponent, //cuenta
    ChangpasswordComponent, 
    NotificationComponent,
    PaymentsCardComponent, 
    AccountDetailsComponent,
    AddUsersComponent, //usuarios
    ShowUsersComponent, 
    UsersComponent,
    //
    MainMComponent,
    RestorePasswordComponent,
    SettingsComponent,
    WelcomeComponent,
    CampaignsComponent,
    EnvioMasivoMensajeComponent,
    EnvioMasivoArchivoComponent,
    MensajePersonalizadoGrupoComponent,
    ArchivoPersonalizadoGrupoComponent,
    ListaDeContactosComponent,
    MisCampaniasComponent,
    CrearContactosComponent,
    EditarContactosComponent,
    MisCampaniasDetallesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    PrimeModule,
    HttpClientModule,
    FormsModule,
    PickerModule,
    GoogleMapsModule,
    ProgressSpinnerModule,
    NgxDocViewerModule,
    SharedModule,
    DialogModule, 
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    ChartModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [RecentmessageService,CountryService,ChatsService,MessagesService,UsersService,ContactsService,ConfirmationService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true }],


  bootstrap: [AppComponent]
})
export class AppModule { }
